import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import authService from '../../services/authService';
import LoadingSpinner from '../common/LoadingSpinner';

interface ProtectedRouteProps {
  isAuthenticated?: boolean;
  children?: React.ReactNode;
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isAuthenticated: isAuthProp,
  children,
  redirectPath = '/login',
}) => {
  const [isChecking, setIsChecking] = useState<boolean>(true);
  const [isAuth, setIsAuth] = useState<boolean>(isAuthProp || false);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      if (isAuthProp !== undefined) {
        setIsAuth(isAuthProp);
        setIsChecking(false);
        return;
      }

      const authenticated = authService.isAuthenticated();
      setIsAuth(authenticated);

      // If authenticated, save the current path
      if (authenticated && location.pathname !== '/login') {
        localStorage.setItem('lastPath', location.pathname);
      }

      setIsChecking(false);
    };

    checkAuth();
  }, [isAuthProp, location.pathname]);

  if (isChecking) {
    return (
      <div className='flex items-center justify-center h-screen'>
        <LoadingSpinner type='border' size='lg' color='border-green-500' />
      </div>
    );
  }

  if (!isAuth) {
    return <Navigate to={redirectPath} state={{ from: location }} />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
